import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  copyCallForActionError,
  copyCallForActionSuccess,
  deleteCallForActionError,
  deleteCallForActionSuccess,
  fetchCallForActionError,
  fetchCallForActionSuccess,
} from './actions'
import {
  CALL_FOR_ACTION_REQUEST_ASYNC,
  COPY_CALL_FOR_ACTION_ASYNC,
  DELETE_CALL_FOR_ACTION_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
} from './constants'

const fetchCallForActionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      CALL_FOR_ACTION_REQUEST_ASYNC.INITIATE,
      PAGINATE_CHANGE,
      SEARCH_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DELETE_CALL_FOR_ACTION_ASYNC.SUCCESS,
      COPY_CALL_FOR_ACTION_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.awarenessCenter.callforaction)
      return true
    }),
    mergeMap(() =>
      api.awarenessCenter
        .getCallForActionPages(
          state$.value.awarenessCenter.callForAction.page || 1,
          state$.value.awarenessCenter.callForAction.search,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          mergeMap((response) => of(fetchCallForActionSuccess(response))),
          catchError((error) => of(epicsErrorHandler(fetchCallForActionError, error, [400]))),
          takeUntil(action$.pipe(ofType(CALL_FOR_ACTION_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const deleteCallForActionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_CALL_FOR_ACTION_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .deleteCallForAction(
          action.payload.id,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) => deleteCallForActionSuccess(response)),
          catchError((error) => of(epicsErrorHandler(deleteCallForActionError, error))),
          takeUntil(action$.pipe(ofType(DELETE_CALL_FOR_ACTION_ASYNC.CANCEL)))
        )
    )
  )

const copyCallForActionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(COPY_CALL_FOR_ACTION_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .copyCallForAction(
          action.payload.id,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) => copyCallForActionSuccess(response)),
          catchError((error) => of(epicsErrorHandler(copyCallForActionError, error, [400]))),
          takeUntil(action$.pipe(ofType(COPY_CALL_FOR_ACTION_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchCallForActionEpic, deleteCallForActionEpic, copyCallForActionEpic)
